export default "__VITE_ASSET__Cb$aQTVh__"